// extracted by mini-css-extract-plugin
export default {"container":"dropzone_container__WLpla"};